import { useState } from "react";
import { ChevronLeft, ChevronRight, ZoomIn } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { useLang } from "../../i18n/LangContext";
import { useSite } from "../../context/SiteContext";
import { fileUrl } from "../../lib/api";
import { SectionHead } from "./Brand";

export const Proofs = () => {
  const { proofs: t } = useLang().t;
  const { site } = useSite();
  const items = site?.proofs || [];
  const [idx, setIdx] = useState(null);
  const cdn = site?.performance?.cdn_base_url;
  const lazy = site?.performance?.lazyload !== false;
  if (!items.length) return null;
  const go = (d) => setIdx((i) => (i + d + items.length) % items.length);
  const cur = idx !== null ? items[idx] : null;

  return (
    <section id="withdraw-proof" className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8" data-testid="proofs-section">
      <SectionHead eyebrow={t.eyebrow} title={t.title} sub={t.sub} />
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        {items.map((p, i) => (
          <button key={p.id} onClick={() => setIdx(i)} data-testid={`proof-card-${i}`} aria-label={t.view}
            className="pay-tile group relative overflow-hidden rounded-2xl border-2 border-[#D4AF37] bg-black text-left">
            <img src={fileUrl(p.image, cdn)} alt={p.caption || "Withdrawal proof"} loading={lazy ? "lazy" : "eager"} className="aspect-[2/3] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black via-black/80 to-transparent p-3 pt-10">
              {p.amount && <p className="font-serif text-lg font-bold gold-text" data-testid={`proof-amount-${i}`}>{p.amount}</p>}
              {p.caption && <p className="text-xs text-zinc-300">{p.caption}</p>}
            </div>
            <span className="absolute right-2 top-2 grid h-8 w-8 place-items-center rounded-full bg-black/70 text-[#D4AF37] opacity-0 transition-opacity group-hover:opacity-100"><ZoomIn size={15} /></span>
          </button>
        ))}
      </div>
      <Dialog open={idx !== null} onOpenChange={(o) => !o && setIdx(null)}>
        <DialogContent className="max-w-md border-[#D4AF37]/40 bg-[#0E0F14] p-3 text-white" data-testid="proof-lightbox">
          <DialogTitle className="sr-only">{t.eyebrow}</DialogTitle>
          <DialogDescription className="sr-only">{cur?.caption}</DialogDescription>
          {cur && (
            <div className="relative">
              <img src={fileUrl(cur.image, cdn)} alt={cur.caption || "Withdrawal proof"} className="max-h-[78vh] w-full rounded-xl object-contain" />
              <p className="mt-3 text-center text-sm"><span className="font-bold text-[#D4AF37]">{cur.amount}</span> {cur.caption && `· ${cur.caption}`}</p>
              {items.length > 1 && <>
                <button onClick={() => go(-1)} aria-label="Previous" data-testid="proof-prev" className="absolute left-2 top-1/2 grid h-9 w-9 -translate-y-1/2 place-items-center rounded-full bg-black/70 text-[#D4AF37]"><ChevronLeft size={18} /></button>
                <button onClick={() => go(1)} aria-label="Next" data-testid="proof-next" className="absolute right-2 top-1/2 grid h-9 w-9 -translate-y-1/2 place-items-center rounded-full bg-black/70 text-[#D4AF37]"><ChevronRight size={18} /></button>
              </>}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
